<iframe id="frame" #frame width="100%" height="100%" class="hide-scroll-bar"></iframe>
